import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { ClampTextProps } from "./types";

export const ClampText = ({
  text,
  lines = 3,
  minCharsForToggle = 160,
  moreLabel,
  lessLabel,
  className = "",
  textClassName = "",
  buttonClassName = "",
}: ClampTextProps) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);

  const showToggle = useMemo(
    () => (text?.length ?? 0) > minCharsForToggle,
    [text, minCharsForToggle],
  );

  if (!text) return null;

  return (
    <span className={clsx("block", className)}>
      <span
        className={clsx("block break-words", textClassName)}
        style={
          expanded
            ? undefined
            : {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: lines,
                overflow: "hidden",
                overflowWrap: "anywhere",
              }
        }
      >
        {text}
      </span>
      {showToggle && (
        <button
          type="button"
          onClick={() => setExpanded((value) => !value)}
          className={clsx(
            "mt-1 self-start block text-xs underline",
            "opacity-80 hover:opacity-100",
            "focus:outline-none focus:ring-2 focus:ring-yellow-300 rounded",
            buttonClassName,
          )}
        >
          {expanded
            ? (lessLabel ?? t("buttons.showLess"))
            : (moreLabel ?? t("buttons.showMore"))}
        </button>
      )}
    </span>
  );
};
